import { render, staticRenderFns } from "./Unitconfig.vue?vue&type=template&id=5f9fc74d&"
import script from "./Unitconfig.vue?vue&type=script&lang=js&"
export * from "./Unitconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports